export const check = "/check";
export const register = "/register";
export const verified = "/verified";
export const validation = "/validation";
export const logout = "/logout";
export const nesdata = "/nesdata";
export const provinces = "/province/show";
export const cities = "/city/show";
export const landingData = "/landing/data";
export const listWeb = "/web/ads";
export const single = "/web/single";
export const adsShow = "/user/ads/show";
export const updateAds = "/user/ads/update";
export const listAds = "/user/ads/list";
export const createAds = "/user/ads/create";
export const toggleMark = "/marked/toggle";
export const listMark = "/marked/list";
export const userDashboard = "/dashboard/user";
export const editProfile = "/profile/edit";
export const myPayments = "/user/peyments";
export const singlePement = "/user/peyment";
export const plans = "/plan/list";
export const buyPlan = "/plan/buy";
export const supportChat = "/support/chat";
export const supportList = "/support/user_list";
export const supportNewQuestion = "/support/new_question";
export const newTicket = "/support/store";
export const checkOffer = "/off/check";
export const payOrPulished = "/user/ads/publish";
export const ShowContactData = "/web/contact_data";
